import styled from "@emotion/styled";

export const StyledPlanCardPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["5"]};
  gap: ${({ theme }) => theme.spacing["1"]};
`;
